import React from 'react';

type SymbolsFacebookCircleIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SymbolsFacebookCircleIcon = ({
  width = 24,
  height = 24,
  color = '#039BE5',
}: SymbolsFacebookCircleIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.00205078125 0.00137524558 35 0.00137524558 35 34.9924361 0.00205078125 34.9924361"
      fill="white"
    />
    <path
      d="M35,17.6031434 C35,7.88118861 27.1649902,0 17.5,0 C7.83500977,0 0,7.88118861 0,17.6031434 C0,26.3893811 6.39949707,33.6718566 14.765625,34.9924361 L14.765625,22.6915521 L10.3222656,22.6915521 L10.3222656,17.6031434 L14.765625,17.6031434 L14.765625,13.7249509 C14.765625,9.31316306 17.378252,6.8762279 21.3756348,6.8762279 C23.2902783,6.8762279 25.2929688,7.22003929 25.2929688,7.22003929 L25.2929688,11.5520629 L23.0862598,11.5520629 C20.9123291,11.5520629 20.234375,12.9089833 20.234375,14.3010756 L20.234375,17.6031434 L25.0878906,17.6031434 L24.3120117,22.6915521 L20.234375,22.6915521 L20.234375,34.9924361 C28.6005029,33.6718566 35,26.3893811 35,17.6031434"
      fill={color}
    />
  </svg>
);
